// document.addEventListener( 'DOMContentLoaded', function () {
//     $('.product_slider').slick({
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//         arrows: true,
//         dots: false,
//     });                  
// });

// document.addEventListener( 'DOMContentLoaded', function () {
//     $('.product_slider').slick({
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         centerMode: true,
//         arrows: true,
//         dots: false,
//         centerPadding: '10px',
//         infinite: true,
//         autoplay: false
//     });                  
// });

slider = () => {

    document.addEventListener( 'DOMContentLoaded', function () {
        const slider =  $('.product_slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '30%',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '20%',
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 552,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
        slider.on('wheel', (function(e) {
            e.preventDefault();
            if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickNext');
            } else {
            $(this).slick('slickPrev');
            }
        }));
    });

    document.addEventListener( 'DOMContentLoaded', function () {
        const mainSlider = $('.js_prod_main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dot: false,
            fade: false,
            infinite: true,
            adaptiveHeight: true,
            // prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
            // nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
            asNavFor: '.js_prod_sub'
        });
        mainSlider.on('wheel', (function(e) {
            e.preventDefault();
            if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickNext');
            } else {
            $(this).slick('slickPrev');
            }
        }));
    });

}
slider();


// document.addEventListener( 'DOMContentLoaded', function () {
//     $('.custom_slider').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         infinite: true,
//         arrows: true,
//         dots: false,
//     });
// });

// function getpcontent() {
//     var d = document.getElementById("product_qty").innerHTML;
//     document.getElementById("d1").innerHTML = d;
// }


// $(document).ready(function(){
//     // Get value on button click and show alert
//     console.log("main_product");
//     $("#product_id").click(function(){
//         var str = $("#product_qty").val();
//         // alert(str);
//         console.log("str",str);
//     });
// });


// let main_btn = document.querySelector(".product-add-to-cart");
// let formDiv = document.querySelector(".main_section");
// let qtyDiv = document.querySelector(".product_slider_section");
// let backBtn = document.querySelector(".main_page_title .back");

// let subBtn = document.querySelector(".submit_btn");

// main_btn.addEventListener("click", ()=>{
//     formDiv.classList.add("active");
//     qtyDiv.classList.add("d-none");
//     qtyDiv.classList.remove("d-block");
// })

// backBtn.addEventListener("click", ()=>{
//     formDiv.classList.remove("active");
//     qtyDiv.classList.add("d-block");
//     qtyDiv.classList.remove("d-none");
// })

// subBtn.addEventListener("click", ()=>{
//     qtyDiv.classList.add("d-none");
//     formDiv.classList.add("d-block");
// })

// var checkboxes = $("input[type='checkbox']"),
// submitButt = $("input[type='submit']");

// checkboxes.click(function() {
//     submitButt.attr("disabled", !checkboxes.is(":checked"));
// });

// $(window).load(function(){
//     var imgSrc = document.querySelector(".list_prod.slick-active .product-item .product-box .product-box-wrap .main_productimg").src;
//     document.getElementById("imageMain").src = imgSrc;
// });

// jQuery(document).ready(function($) {
//     var alterClass = function() {
//       var ww = document.body.clientWidth;
//       if (ww <= 767) {
//             $('.collum-hover').addClass('active_class');
//         } 
//         else{
//         };
//     };
//     // $(window).resize(function(){
//     //   alterClass();
//     // });
//     //Fire it when the page first loads:
//     alterClass();
// });

// closeBg = () => {
//     // let mainBg = document.querySelector('.black-bg');
//     let clickBg = document.querySelector(".black-bg");  
//     clickBg.addEventListener("click",()=>{
//         alert('clicked');
//     });
// }
// closeBg();

// function removeBg(){
//     $('.black-bg').on('click', function() {
//       $('.black-bg').removeClass('active');
//       $('#side_cart').removeClass('active');
//     });
// }

// removeBg();


// var time = 5000;

// setInterval(function(){
//     $('.js-open-minicart').on('click', function() {
//         $('.js-minicart').addClass('active');
//         $('.bg-minicart').addClass('active');
//         $('.contentbody').addClass('activecart');
//         $('body').addClass('cartover');
//     });
// },time);

// setInterval(function(){
//     $('ul').find('li')
//            .addClass('some-class')
//   },time);


// $('.enj-add-to-cart-btn').on('submit', function(event) {
//     event.preventDefault(); // prevent default form submission
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: $(this).serialize(),
//       dataType: 'json',
//       success: function() {
//         // Do something on success (e.g. show a success message)
//         alert("add");
//       },
//       error: function() {
//         // Do something on error (e.g. show an error message)
//         alert("remove");
//       }
//     });
//   });




//   qauntityChange = () => {
//     let plusItem = document.querySelector(".qty-selector-wrap .qty_wrap .qty-plus");
//     let minusItem = document.querySelector(".qty-selector-wrap .qty_wrap .qty-min");

//     if(plusItem){
//         plusItem.addEventListener("click",(e)=>{
//             // debugger;
//             // console.log('plus');
//             let that = e.currentTarget;
//             let parent = that.closest('.qty-selector-wrap');
//             let target = document.querySelector('.product_qty_num',parent);
            
//             let value = parseInt(target.value) + 1;
//             target.value = value;

//         });
//     }

//     if(minusItem){
//         minusItem.addEventListener("click",(e)=>{
//             let that = e.currentTarget;
//             let parent = that.closest('.qty-selector-wrap');
//             let target = document.querySelector('.product_qty_num',parent);
//             if(target.value > 1){
//                 let value = parseInt(target.value) - 1;
//                 target.value = value;
//             }
//         });
//     }
// }

// qauntityChange();



// toggleMain = () => {
//     let toggleBtns = document.querySelector(".toggle-menumobile");
//     let toggleMenu = document.querySelector(".collapses");

//     toggleBtns.addEventListener("click", ()=>{
//         toggleMenu.classList.toggle("active");
//     })
// }
// toggleMain();


// var el = document.querySelector('.toggle-me');

// let toggleBtns = document.querySelectorAll(".toggle-menumobile");
// let toggleMenu = document.querySelectorAll(".collapses");

// toggleBtns.forEach(function(element){
//     element.addEventListener("click",(e)=>{
//         let that = e.preventDefault;
//         that.classList.toggle('active');
//         let subMenu = this.nextElementSibling;
//         if (subMenu.classList.contains("collapses")) {
//             subMenu.classList.toggle('active');
//         }
//         // toggleMenu.classList.toggle('active');
//     })
// })

// toggleBtns.onclick = function() {
//     toggleMenu.classList.toggle('active');
// }


// tx.executeSql('SELECT * FROM locations WHERE lDeleted != 1',
//   [],
//   function(tx,results){
//     var len = results.rows.length;
//     for (var i=0; i<len; i++){
//       $('#productSelect-option-0').append('<option value="'+results.rows.item(i).ID+
//         '" class="dropDownBlk">'+results.rows.item(i).lTitle+'</option>');
//     }
//     $('#productSelect-option-0').append('<option value="0">Add new location...</option>')
//   },
//   errorCB
// );

// $("#productSelect-option-0").trigger("change");


// jQuery(".toggle-menumobile").click(function(){
//     // $(".collapses").removeClass("active");
//     setTimeout(function() {
//         if($(this).hasClass('active')){
//             console.log('working');
//             $(this).closest('.menu-horizon-list').addClass("subactive");  
//         }else{
//             console.log(' toogle off');

//             $(this).closest('.menu-horizon-list').removeClass("subactive");         
//         }
//     }, 300);
// });

jQuery(document).ready(function () {
    $('a.toggle-menumobile').click(function () {
        $(this).siblings('.collapses').toggleClass("show");
    });
});